export type SlideKind =
    | "splash"
    | "introCard"
    | "questionIntro"
    | "question"
    | "scoreSlide"
    | "shareSlide";

export interface ImageMeta {
    url: string;
    alt?: string;
    title?: string;
}

export interface BaseSlide {
    kind: SlideKind;
    id: string;
    route: string;
    bgColor?: string;
}

export interface SplashSlide extends BaseSlide {
    kind: "splash";
    headline: string;
}

/* Intro */

// export interface IntroBasicSlide extends BaseSlide {
//     kind: "introBasic";
//     headline: string;
//     body: string;
//     image?: ImageMeta | null;
//     ctaLabel?: string;
// }

export interface IntroSubCard {
    headline?: string;
    body?: string;
    images?: ImageMeta[];
    ctaLabel?: string;
}

export interface IntroCardSlide extends BaseSlide {
    kind: "introCard";
    headline: string;
    body: string;
    mainImage?: ImageMeta | null;
    iconRow?: ImageMeta[];
    disclaimer?: string;
    ctaLabel?: string;
    templateKey?: string;
    subCard?: IntroSubCard | null;
}

/* Question intro */

export interface QuestionIntroSlide extends BaseSlide {
    kind: "questionIntro";
    headline: string;
    questionId: string;
}

/* Questions */

export interface ChoiceItem {
    label: string;
    isCorrect: boolean;
}

export interface QuestionFeedbackConfig {
    headlineCorrect: string;
    headlineIncorrect: string;
    spanCorrect?: string;
    spanIncorrect?: string;
    bodyHtml: string;
    image?: ImageMeta | null;
    ctaLabel?: string;
}

export interface QuestionSlide extends BaseSlide {
    kind: "question";
    questionId: string;
    category: string;
    questionText: string;
    hint?: string;
    image?: ImageMeta | null;
    scoreImage?: ImageMeta | null;
    choices: ChoiceItem[];
    correctValue?: string;
    feedback: QuestionFeedbackConfig;
}

/* Score & Share */

export interface ScoreSlide extends BaseSlide {
    kind: "scoreSlide";
    headline: string;
    body: string;
    resourcesLabel: string;
    resourcesUrl: string;
    shareLabel: string;
    resourcesBlock?: ResourcesBlock;
}

export interface ShareSlide extends BaseSlide {
    kind: "shareSlide";
    headline: string;
    body: string;
    images?: ImageMeta[];
    shareMessage: string;
    ctaLabel: string;
    shareUrlOverride?: string;
    shareImageUrl?: string;
}

// Resources

export interface ResourcesCard {
    image: ImageMeta;
    headline: string;
    copy: string;
    ctaLabel: string;
    ctaUrl: string;
}

export interface ResourcesBlock {
    headline: string;
    items: ResourcesCard[];
}

export type Slide =
    | SplashSlide
    | IntroCardSlide
    | QuestionIntroSlide
    | QuestionSlide
    | ScoreSlide
    | ShareSlide;

export type QuestionProgressSlide = QuestionSlide;

export interface AnswerEntry {
    selectedIndex: number;
    isCorrect: boolean;
}

export type AnswerRecord = Record<string, AnswerEntry>;

export function isQuestionSlide(
    slide: Slide | undefined,
): slide is QuestionSlide {
    return (
        (!!slide && slide.kind === "question") ||
        slide?.kind === "questionIntro"
    );
}
